import React from "react";
// outsource
import { Modal, Button, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const PayoutDownloadOptionDialog = ({ open, onClose, onDownloadPayoutList, onDownloadPayoutCard }) => {
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="download-option-wrap">
        <Row justify="space-between" align="middle" style={{ marginBottom: 18 }}>
          <Col>
            <span className="download-option-title">Download Option</span>
          </Col>
          <Col>
            <button type="button" className="download-option-close" onClick={onClose}>
              <CloseOutlined />
            </button>
          </Col>
        </Row>
        <Row className="download-option-actions" gutter={[12, 0]}>
          <Col>
            <Button
              type="primary"
              size="small"
              className="download-option-list-btn"
              onClick={onDownloadPayoutList}
            >
              Payout List (.xls)
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              size="small"
              className="download-option-card-btn"
              onClick={onDownloadPayoutCard}
            >
              Payout Card
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={500}
      onCancel={onClose}
      className="download-option-modal"
      maskClosable
    >
      {renderBody()}
    </Modal>
  );
};

export default PayoutDownloadOptionDialog;
